/**
 * TeamSystem Impact - Notifications API Client
 */

import { apiClient } from './client';
import type { Notification, UnreadCountResponse } from '@teamsystem-impact/shared';

const BASE_PATH = '/notifications';

export const notificationsApi = {
  getNotifications: async (params?: {
    unreadOnly?: boolean;
    limit?: number;
    offset?: number;
  }): Promise<Notification[]> => {
    const response = await apiClient.get<Notification[]>(BASE_PATH, {
      params: {
        unreadOnly: params?.unreadOnly?.toString(),
        limit: params?.limit?.toString(),
        offset: params?.offset?.toString(),
      },
    });
    return response.data;
  },

  getUnreadCount: async (): Promise<number> => {
    const response = await apiClient.get<UnreadCountResponse>(`${BASE_PATH}/unread-count`);
    return response.data.count;
  },

  markAsRead: async (id: string): Promise<Notification> => {
    const response = await apiClient.patch<Notification>(`${BASE_PATH}/${id}/read`);
    return response.data;
  },

  markAllAsSeen: async (): Promise<{ modified: number }> => {
    const response = await apiClient.patch<{ modified: number }>(`${BASE_PATH}/seen-all`);
    return response.data;
  },

  markAllAsRead: async (): Promise<{ modified: number }> => {
    const response = await apiClient.patch<{ modified: number }>(`${BASE_PATH}/read-all`);
    return response.data;
  },
};
